import { useQuery } from "@tanstack/react-query";
import { Form, message } from "antd";
import { Dispatch, SetStateAction } from "react";
import { IoIosArrowBack } from "react-icons/io";
import { useDispatch, useSelector } from "react-redux";
import { listServicesCategories } from "../../../network/service";
import { queryKeys } from "../../../services/react-query/queryKeys";
import { updateStep2 } from "../../../services/store/slices/onboarding";
import Services from "../Services";

type Props = {
  nextStep: () => void;
  data: any;
  updateData: Dispatch<SetStateAction<{ name: string; email: string }>>;
};

const Step2 = ({ nextStep }: Props) => {
  const dispatch = useDispatch();
  const {
    data: services,
    isLoading,
    isError,
  } = useQuery([queryKeys?.listServicesOnboarind], () =>
    listServicesCategories({ is_parent: 1, with_icon: 1 })
  );
  const { service_id } = useSelector((state: any) => state.SalonProfile.step2);
  const { team_size_id } = useSelector(
    (state: any) => state.SalonProfile.step1
  );

  const onFinish = (values: any) => {
    dispatch(updateStep2(values));
    values?.service_id?.length > 0
      ? nextStep()
      : message.warning("لم تختر اي خدمه");
  };
  console.log(services);

  return (
    <Form
      name="step2"
      onFinish={onFinish}
      layout={"vertical"}
      dir="rtl"
      initialValues={{
        service_id: service_id || [],
      }}
    >
      <Services ser={services?.data || []} isLoading={isLoading} />
      <Form.Item className="w-full flex justify-center items-center mt-0 !mb-0">
        <button
          type="submit"
          className="rounded-full border-solid border-color-primary border-t-2 border-b-2 border-b-white border-r-2 border-l-2 border-l-white rotate-45 cursor-pointer bg-[#EEF0FF] w-14 h-14"
        >
          <IoIosArrowBack className="w-5 h-5 text-color-primary -rotate-45 mt-1" />
        </button>
      </Form.Item>
    </Form>
  );
};

export default Step2;
